/**
 * Document Templates Configuration
 * Static templates available for download in Crisis Details > Incident Documentation > Notes and Documentation
 */

export const INCIDENT_DOCUMENT_TEMPLATES = [
  {
    id: 'cmt-meeting-template',
    name: 'CMT Meeting Template',
    description: 'Crisis Management Team meeting documentation template',
    filename: 'CMT_Meeting_Template.docx',
    downloadUrl: '/templates/incident-documentation/CMT_Meeting_Template.docx',
    icon: '📋'
  },
  {
    id: 'sitrep-template',
    name: 'SITREP Template', 
    description: 'Situation Report documentation template',
    filename: 'SITREP_Template.docx',
    downloadUrl: '/templates/incident-documentation/SITREP_Template.docx',
    icon: '📊'
  }
];

/**
 * Download a template file to the user's device
 * @param {Object} template - Template object from INCIDENT_DOCUMENT_TEMPLATES
 */
export const downloadTemplate = (template) => {
  try {
    const link = document.createElement('a');
    link.href = template.downloadUrl;
    link.download = template.filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log(`📥 Template downloaded: ${template.name}`);
  } catch (error) {
    console.error('❌ Error downloading template:', error);
    alert('Error downloading template. Please try again.');
  }
}; 